import {
  PROJECT,
  SOLUTION,
  IMPORT_SERVICES,
  SET_VEHICLES,
  SET_VEHICLE_TYPES,
  PROJECT_OPTIONS,
  SET_DRIVERS,
  PUBLICATION_SETTINGS,
  CLEAR_DRIVER_LOCATIONS,
  LOCKED_ROUTES,
  SELECTED_VEHICLES,
  CHANGED_VEHICLES,
  RESET_STATE,
  SET_PROJECT_DETAILS,
  EDIT_MODE_TOGGLE,
  SET_PROJECT_STARTED,
  SET_SHOWING_ROUTE_ID,
  UPDATE_ROUTES_ETAS
} from "../actions/types";

const initialState = {
  vrp: {
    stops: [],
    configuration: {
      algorithm: "time",
      default_duration: "5",
      default_load: "1",
      distance_units: "km",
      allow_late_stops_minute: "",
      allow_reload: false,
      fixed_departure_time: false
    }
  },
  importedData: {
    valid: [],
    invalid: []
  },
  vehicleTypes: [],
  vehicles: [],
  selectedVehicles: [],
  changedVehicles: [],
  drivers: [],
  // driverLocations: {},
  solution: null,
  lockedRoutes: {},
  status: "",
  published: false,
  publication_settings: {
    fulfill_stops_in_any_order: false,
    allowed_to_call_recipient: false,
    require_name_with_signature: false
  },
  project_started: false,
  showingRouteId: ""
};

export function projectReducer(state = initialState, action) {
  switch (action.type) {
    case PROJECT:
      return {
        ...state,
        ...action.obj,
        publication_settings: action.obj.publication_settings || {}
      };

    case PROJECT_OPTIONS:
      return {
        ...state,
        vrp: {
          ...state.vrp,
          configuration: {
            ...state.vrp.configuration,
            ...action.obj
          }
        }
      };
    case SOLUTION:
      return {
        ...state,
        solution: action.obj
      };

    case UPDATE_ROUTES_ETAS: {
      // Track D: apply live-recomputed ETAs (arr_time) from the driver-app relay.
      // Identity-preserving: only routes/groups whose stops actually changed get NEW references, so
      // memoized rows bail out. Deliberately does NOT re-run getFormattedRoutes/getRouteColors (route
      // order and colors are unaffected by arr_time) — that's the costly full rebuild SOLUTION does.
      const etas = action.ETAs;
      const solution = state.solution;
      if (!solution || !solution.routes || !etas) {
        return state;
      }

      const patchedById = {};
      const newRoutes = solution.routes.map(route => {
        const routeEtas = etas[route.id];
        if (!routeEtas || !route.stops) return route;
        let changed = false;
        const newStops = route.stops.map(stop => {
          const next = routeEtas[stop.id];
          if (next != null && next !== stop.arr_time) {
            changed = true;
            return { ...stop, arr_time: next };
          }
          return stop;
        });
        if (!changed) return route;
        const newRoute = { ...route, stops: newStops };
        patchedById[route.id] = newRoute;
        return newRoute;
      });

      // Nothing actually changed -> return the SAME state ref so connected components don't re-render.
      if (Object.keys(patchedById).length === 0) {
        return state;
      }

      // Swap only the affected route refs inside routeGroups (what the route list renders from);
      // unchanged groups/backhaul-arrays keep their identity.
      const oldGroups = solution.routeGroups || {};
      const newGroups = {};
      Object.keys(oldGroups).forEach(groupId => {
        let groupChanged = false;
        const newBackhaulGroups = oldGroups[groupId].map(backhaulGroup => {
          let bhChanged = false;
          const newBh = backhaulGroup.map(route => {
            const patched = patchedById[route.id];
            if (patched) {
              bhChanged = true;
              return patched;
            }
            return route;
          });
          if (bhChanged) {
            groupChanged = true;
            return newBh;
          }
          return backhaulGroup;
        });
        newGroups[groupId] = groupChanged ? newBackhaulGroups : oldGroups[groupId];
      });

      return {
        ...state,
        solution: {
          ...solution,
          routes: newRoutes,
          routeGroups: newGroups
        }
      };
    }

    case IMPORT_SERVICES:
      return {
        ...state,
        importedData: {
          valid: action.valid,
          invalid: action.invalid,
          type: action.import_type
        }
      };
    case SET_VEHICLES:
      return {
        ...state,
        vehicles: action.arr
      };
    case SET_VEHICLE_TYPES:
      return {
        ...state,
        vehicleTypes: action.arr
      };

    case SELECTED_VEHICLES:
      return {
        ...state,
        selectedVehicles: action.arr
      };
    case CHANGED_VEHICLES:
      return {
        ...state,
        changedVehicles: action.arr
      };

    case SET_DRIVERS:
      return {
        ...state,
        drivers: action.arr
      };

    case CLEAR_DRIVER_LOCATIONS:
      return {
        ...state,
        driverLocations: {}
      };

    case LOCKED_ROUTES:
      return {
        ...state,
        lockedRoutes: action.obj
      };

    case PUBLICATION_SETTINGS:
      return {
        ...state,
        publication_settings: {
          ...state.publication_settings,
          ...action.obj
        }
      };

    case SET_PROJECT_DETAILS:
      return {
        ...state,
        name: action.payload.name,
        project_date: action.payload.date
        // id: action.payload.id || state.id
      };
    case SET_PROJECT_STARTED:
      return {
        ...state,
        project_started: action.payload
      };
    case SET_SHOWING_ROUTE_ID:
      return {
        ...state,
        showingRouteId: action.payload.routeId
      };
    case RESET_STATE:
      return {
        ...initialState,
        vehicleTypes: state.vehicleTypes,
        drivers: state.drivers,
        id: action.id || null
      };
    default:
      return state;
  }
}
